export default "__VITE_ASSET__55b9d7c3__"